const resetPasswordFormConstantsAR = {
  resetPasswordFormTitle: 'أنشئ كلمة مرور جديدة',
  resetPasswordSubFormTitle:
    'يرجى إنشاء والتحقق من كلمة مرور آمنة جديدة لحسابك.',
  resetPasswordFormButtonText: 'تابع',
  resetPasswordFormPasswordLabel: 'كلمة المرور',
  resetPasswordFormConfirmPasswordLabel: 'تأكيد كلمة المرور',
  passwordLength: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
  requireUpperCase: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل',
  requireLowerCase: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل',
  requireNumber: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل',
  requireSpecialCharacter:
    'جب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل [. ،! @ #؟ ]',
  passwordNotMatched: 'كلمات المرور غير متطابقة',
  emptyConfirmPassword: 'يرجى ملء ملف تأكيد كلمة المرور',
  linkExpiredText : 'انتهت صلاحية الرابط'
};

export default resetPasswordFormConstantsAR;
